import React, { FC } from "react";
import { Button } from "@material-ui/core";
import { postRequest } from "../../../apis/axiosAction";
import Encoding from "encoding-japanese";
import { DateTime } from "luxon";

const KeieiShindanStoreScoreDataButton: FC<{
  csvZoCode?: string;
  csvDoCode?: string;
  addMonth: number;
}> = ({ csvZoCode, csvDoCode, addMonth }) => {
  const [executeFlg, setExecuteFlg] = React.useState(false);
  const [executeFlg2, setExecuteFlg2] = React.useState(false);
  const [searchZoCode] = React.useState(csvZoCode);
  const [searchDoCode] = React.useState(csvDoCode);

  // 個店毎の得点推移
  const getKeieiShindanData = async () => {
    let date: any = DateTime.local().toFormat("yyyyMMdd");

    const apiParams = {
      "api-name": "storeTransitionData",
      target_date: "selectedBaseDate",
      zo_code: searchZoCode,
      do_code: searchDoCode,
    };
    const url =
      process.env.REACT_APP_API_URL_J11SPB22 + "keieishindan/storeTransitionData-phase2";

    setExecuteFlg(true);
    return postRequest(url, apiParams)
      .then((res) => {
        let headerRow: any[] = [
          "ZOコード",
          "ZO",
          "DOコード",
          "DO",
          "OFCコード",
          "OFC",
          "店舗コード",
          "店舗名",
        ];

        let dataList: any[] = res.data.dataList;
        let sortDataList: any[] = [];
        if (dataList) {
          let resultList = dataList[0].resultList;
          let monthList = dataList[0].monthList;

          for (let j = 0; j < monthList.length; j++) {
            headerRow.push(monthList[j].name.slice(1));
          }
          for (let i = 0; i < resultList.length; i++) {
            let sortData: any = {};
            let result: any = resultList[i];
            sortData.zocode = result.zocode;
            sortData.zoname = result.zoname;
            sortData.docode = result.docode;
            sortData.doname = result.doname;
            sortData.ofc_code = result.ofc_code;
            sortData.ofc_name = result.ofc_name;
            sortData.tenpo_code = result.tenpo_code;
            sortData.tenpo_name = result.tenpo_name;
            for (let j = 0; j < monthList.length; j++) {
              sortData[monthList[j].name] = result[monthList[j].name];
            }
            sortDataList.push(sortData);
          }
        }

        const dataRows = sortDataList.map(({ tableData, ...row }) => {
          return Object.values(row);
        });

        const delimiter = ",";
        const data: any = [headerRow, ...dataRows]
          .map((e: any) => e.join(delimiter))
          .join("\n");

        let fileName = "KeieiShindanStoreTransitionData_" + date;

        const exportFileName = `${fileName}.csv`;

        let convertData: any = new Uint8Array(
          Encoding.convert(Encoding.stringToCode(data), "SJIS", "UNICODE")
        );
        const a = document.createElement("a");
        a.href = URL.createObjectURL(
          new Blob([convertData], { type: "text/csv" })
        );
        a.setAttribute("download", exportFileName);
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
      })
      .finally(() => {
        setExecuteFlg(false);
      });
  };

  // 個店毎評価一覧出力
  const getStoreScoreData = async () => {
    let date: any = DateTime.local().toFormat("yyyyMMdd");
    const apiParams = {
      "api-name": "storeEvaluationData",
      target_date: addMonth,
      zo_code: searchZoCode,
      do_code: searchDoCode,
    };
    const url =
      process.env.REACT_APP_API_URL_J11SPB22 + "keieishindan/storeEvaluationData-phase2";

    setExecuteFlg2(true);
    return postRequest(url, apiParams)
      .then((res) => {
        let itemCountList = [20, 9, 8, 8, 5]; //各項目の数
        let headerRow: any[] = [
          "提出日",
          "ZOコード",
          "ZO",
          "DOコード",
          "DO",
          "OFCコード",
          "OFC",
          "店舗コード",
          "店舗名",
        ];
        let categorySum: any[] = [
          "遵守項目",
          "基本四原則",
          "従業員の募集採用・教育",
          "体制強化",
          "予算・行為計画",
        ];
        let categoryIdx = 0;
        let itemCountIndex = 0;
        let itemCount = itemCountList[itemCountIndex];
        let totalItemCount = 0;
        for (let i = 1; i <= 50; i++) {
          headerRow.push("No" + i);
          if ((i - totalItemCount) % itemCount == 0 || i == 50) {
            headerRow.push(categorySum[categoryIdx]);
            categoryIdx++;
            totalItemCount += itemCount;
            itemCountIndex++;
            itemCount = itemCountList[itemCountIndex];
          }
        }

        let dataList: any[] = res.data.dataList;
        let sortDataList: any[] = [];
        if (dataList) {
          for (let i = 0; i < dataList.length; i++) {
            let sortData: any = {};
            let result: any = dataList[i];
            sortData.approve_day = result.approve_day;
            sortData.zocode = result.zocode;
            sortData.zoname = result.zoname;
            sortData.docode = result.docode;
            sortData.doname = result.doname;
            sortData.ofc_code = result.ofc_code;
            sortData.ofc_name = result.ofc_name;
            sortData.tenpo_code = result.tenpo_code;
            sortData.tenpo_name = result.tenpo_name;
            categoryIdx = 1;
            itemCountIndex = 0;
            itemCount = itemCountList[itemCountIndex];
            totalItemCount = 0;
            for (let j = 1; j <= 50; j++) {
              // 遵守項目（No1-20）は×○に変換（1=×、0=○）
              if (j <= 20) {
                const value = result["_" + j];
                // 数値に変換してから比較
                const numValue = Number(value);
                sortData["_" + j] = numValue === 1 ? "×" : numValue === 0 ? "○" : value;
              } else {
                sortData["_" + j] = result["_" + j];
              }
              if ((j - totalItemCount) % itemCount == 0 || j == 50) {
                sortData["sum_" + categoryIdx] = result["sum_" + categoryIdx];
                categoryIdx++;
                totalItemCount += itemCount;
                itemCountIndex++;
                itemCount = itemCountList[itemCountIndex];
              }
            }

            sortDataList.push(sortData);
          }
        }

        const dataRows = sortDataList.map(({ tableData, ...row }) => {
          return Object.values(row);
        });
        const delimiter = ",";
        const data: any = [headerRow, ...dataRows]
          .map((e: any) => e.join(delimiter))
          .join("\n");

        let fileName = "KeieiShindanStoreEvaluationData_" + date;

        const exportFileName = `${fileName}.csv`;

        let convertData: any = new Uint8Array(
          Encoding.convert(Encoding.stringToCode(data), "SJIS", "UNICODE")
        );
        const a = document.createElement("a");
        a.href = URL.createObjectURL(
          new Blob([convertData], { type: "text/csv" })
        );
        a.setAttribute("download", exportFileName);
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
      })
      .finally(() => {
        setExecuteFlg2(false);
      });
  };

  return (
    <>
      {addMonth === 0 ? (
        <Button
          variant="contained"
          color="primary"
          size="small"
          style={{ width: "220px", marginRight: "10px" }}
          onClick={() => getKeieiShindanData()}
          disabled={executeFlg ? true : false}
        >
          {!executeFlg ? "「個店毎の得点推移」CSV出力" : "CSV出力中"}
        </Button>
      ) : (
        ""
      )}
      <Button
        variant="contained"
        color="primary"
        size="small"
        style={{ width: "250px", marginRight: "10px" }}
        onClick={() => getStoreScoreData()}
        disabled={executeFlg2 ? true : false}
      >
        {!executeFlg2
          ? addMonth === 0
            ? "今月分「個店毎評価一覧」CSV出力"
            : "先月分「個店毎評価一覧」CSV出力"
          : "CSV出力中"}
      </Button>
    </>
  );
};
export default KeieiShindanStoreScoreDataButton;
